<script>
  import { onMount } from "svelte";

  import Modal from './Modal.svelte';
  import ServiceThumbnail from './ServiceThumbnail.svelte';
  import ServiceRun from './ServiceRun.svelte';
  import Button from './Button.svelte';
  import Container from './Container.svelte';
  import WaitingFor from './WaitingFor.svelte';

  import { publishedService } from '../stores.js';

  export let user;

  let services = [];
  let expanded = false;
  let detailView = false;

  publishedService.subscribe(metadata => {
    if (services[0] && services[0][0] === 'you') {
      services = services.slice(1);
    }
    services = [['you', metadata], ...services];
  })

  onMount(async () => {
    services = Object.entries(await user.children);
  })

</script>

<Container>
  {#if user?._state?.attributes?.size}
    <div class="horizontalScroll">
      {#each services.slice(0, expanded? 10: 3) as [owner, metadata]}
        <ServiceThumbnail {owner} {metadata} on:click={() => {detailView = [owner, metadata]}}/>
      {/each}
    </div>
    <Button style="width: 100%; background-color: #222; color: #aaa;" on:click={() => {expanded = !expanded}}>
      Show {expanded? "Less" : "More"}
    </Button>
  {:else}
    <WaitingFor/>
  {/if}
</Container>

<Modal visible={detailView}>
  <ServiceRun owner={detailView[0]} metadata={detailView[1]} />
  <br/>
  <Button on:click={() => {detailView = false}}>Close</Button>
</Modal>


<style>
  .horizontalScroll {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }
</style>